import axiosInstance from '../utils/axiosInstance';

const BASE_PATH = '/admin/sales-course-codes';

function sanitizeParams(params = {}) {
  const result = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed !== '') {
        result[key] = trimmed;
      }
      return;
    }
    result[key] = value;
  });
  return result;
}

export async function listCourseCodes(params = {}) {
  const response = await axiosInstance.get(BASE_PATH, {
    params: sanitizeParams(params),
  });
  return response.data;
}

export async function createCourseCode(payload) {
  const response = await axiosInstance.post(BASE_PATH, payload);
  return response.data;
}

export async function updateCourseCode(id, payload) {
  const response = await axiosInstance.put(`${BASE_PATH}/${id}`, payload);
  return response.data;
}

export async function deleteCourseCode(id) {
  const response = await axiosInstance.delete(`${BASE_PATH}/${id}`);
  return response.data;
}

export async function listExtraCodes(courseCodeId) {
  const response = await axiosInstance.get(`${BASE_PATH}/${courseCodeId}/extra-codes`);
  return response.data;
}

export async function createExtraCode(courseCodeId, payload) {
  const response = await axiosInstance.post(`${BASE_PATH}/${courseCodeId}/extra-codes`, payload);
  return response.data;
}

export async function updateExtraCode(courseCodeId, extraId, payload) {
  const response = await axiosInstance.put(`${BASE_PATH}/${courseCodeId}/extra-codes/${extraId}`, payload);
  return response.data;
}

export async function deleteExtraCode(courseCodeId, extraId) {
  const response = await axiosInstance.delete(`${BASE_PATH}/${courseCodeId}/extra-codes/${extraId}`);
  return response.data;
}

export default {
  listCourseCodes,
  createCourseCode,
  updateCourseCode,
  deleteCourseCode,
  listExtraCodes,
  createExtraCode,
  updateExtraCode,
  deleteExtraCode,
};
